import { render, staticRenderFns } from "./AppIpadBackground.vue?vue&type=template&id=2d06c66c&"
import script from "./AppIpadBackground.vue?vue&type=script&lang=js&"
export * from "./AppIpadBackground.vue?vue&type=script&lang=js&"
import style0 from "./AppIpadBackground.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports